import React, { useState } from "react";
import Sidebar from "../../../../../../../CommonComponets/SideBar";
import { BiPlusCircle } from "react-icons/bi";
import Swal from "sweetalert2";

const AddBrochure = ({ addOpen, setAddOpen }) => {
  const [search, setSearch] = useState("");

  const brochures = [
    {
      id: "2",
      name: "Awadh City",
      project: "AWADH CITY",
      file: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171645.pdf",
    },
    {
      id: "3",
      name: "Awadh City Ph-3",
      project: "AWADH CITY PH-3",
      file: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171737.pdf",
    },
    {
      id: "4",
      name: "Awadh City D block Map",
      project: "AWADH CITY",
      file: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171818.pdf",
    },
    // 👉 you can add more data here
  ];

  const handleFilter = () => {
    // console.log("Filter clicked");
  };

  const handleCancel = () => {
    setSearch("");
  };

  const handleAdd = (id, name) => {
    // console.log("Added:", id, name);
  };

  const filteredData = brochures.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );

  const handleStatusChange = () => {
    Swal.fire({
      title: "",
      html: `
            <div style="text-align:center;">
              <div style="
                width:80px;
                height:80px;
                border-radius:50%;
                background:#e6f4ea;
                display:flex;
                align-items:center;
                justify-content:center;
                margin:0 auto 15px;
              ">
                <i>
                 <svg width="50" height="50" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" fill="#4CAF50" />
          <path
          fill="none"
            d="M7 12l3 3 7-7"
            stroke="#fff"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
                </i>
              </div>
      <p style="font-size:16px; color:#555;" class='mb-0 '>Do you want to add this brochure</p>
      <h4 class='text-success'>Tapovan</h4>
              <p style="font-size:16px; color:#555;">
               To Your Brochure List
              </p>
            </div>
          `,
      showCancelButton: true,
      confirmButtonText: "Yes, Change it",
      cancelButtonText: "Cancel",

      // Colors
      confirmButtonColor: "#4caf50",
      cancelButtonColor: "#e0e0e0",

      // Remove default icon
      icon: undefined,

      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Status Changed!");
      }
    });
  };

  return (
    <>
      {addOpen && (
        <Sidebar
          setIsFilter={() => {
            setAddOpen(false);
          }}
          heading={"Add Your Brochure"}
          onClose={() => {
            setAddOpen(false);
          }}
        >
          <div className="overflow-x-scroll">
            <div className="row p-0 m-0 align-items-center mb-2">
              <div className="col-sm-5 p-0">
                <div className="icon-form mb-3 mb-sm-0">
                  <span className="form-icon">
                    <i className="ti ti-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search here..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-sm-7 p-0">
                <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                  <button
                    className="mx-2 px-3 py-2 btn btn-warning"
                    onClick={handleFilter}
                  >
                    <i className="ti ti-filter-share"></i> Filter
                  </button>

                  <button
                    className="btn px-3 py-2"
                    style={{ background: "#6F7A7A", color: "aliceblue" }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <div className=" mt-3 m-0">
              <div className="overflow-x-auto table-responsive">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>Sr. No.</th>
                      <th>Brochure</th>
                      <th>Project</th>
                      <th>File</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.project}</td>

                        <td>
                          <a href={item.file} target="_blank" rel="noreferrer">
                            <img
                              src="https://erp.ravbiz.in/UploadFile/pdf-icon.jpg"
                              style={{ height: "25px", width: "25px" }}
                              alt="pdf"
                            />
                          </a>
                        </td>

                        <td>
                          <div
                            onClick={handleStatusChange}
                            className="btn px-3 py-2  w-auto d-inline-flex justify-content-center column-gap-1 align-content-center btn-outline-success"
                          >
                            <i>
                              <BiPlusCircle size={15} />
                            </i>
                            Add To List
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Sidebar>
      )}
    </>
  );
};

export default AddBrochure;
